import type { IntlShape, MessageDescriptor } from 'react-intl';

import messages from './messages';

// The fixed, platform-wide question catalog (`TermsOfUseQuestion` — one
// universal set of questions for the whole platform, not org-authored). The
// seeded `questionText` is a bilingual literal ("Poslovni model / Business
// Model"), not react-intl-localized, so every buyer-facing Terms of Use
// dialog shows this translated title instead. Mirrors `OrgTermsOfUseForm`'s
// `TRANSLATED_QUESTIONS` map.
const TRANSLATED_QUESTION_TITLES: Record<string, MessageDescriptor> = {
  business_model: messages.businessModelTitle,
  payment_policy: messages.paymentPolicyTitle,
};

const TRANSLATED_QUESTION_DESCRIPTIONS: Record<string, MessageDescriptor> = {
  business_model: messages.businessModelDescription,
  payment_policy: messages.paymentPolicyDescription,
};

export function getTermsOfUseQuestionTitle(
  question: { questionKey: string; questionText: string },
  formatMessage: IntlShape['formatMessage'],
) {
  const translatedTitle = TRANSLATED_QUESTION_TITLES[question.questionKey];
  return translatedTitle
    ? formatMessage(translatedTitle)
    : question.questionText;
}

// The long-form explanation for a translated question, shown as an
// info-icon tooltip next to its title (see `OrgTermsOfUseForm`) rather than
// as a paragraph under it — `undefined` for a question outside the fixed
// catalog, which falls back to its own seeded `description` instead.
export function getTermsOfUseQuestionTooltip(
  question: { questionKey: string },
  formatMessage: IntlShape['formatMessage'],
) {
  const translatedDescription =
    TRANSLATED_QUESTION_DESCRIPTIONS[question.questionKey];
  return translatedDescription
    ? formatMessage(translatedDescription)
    : undefined;
}
